import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { PuiMessageType } from './message-config';

let nextId = 0;

@Component({
    selector: 'pui-message',
    templateUrl: 'message.component.html',
    styleUrls: [`./message.component.scss`],
    encapsulation: ViewEncapsulation.None
})

export class PuiMessageComponent implements OnInit {
    @Input() id = `pui-message-${nextId++}`;
    @Input()
    get type() {
        return this.messageType;
    }
    set type(at: any | PuiMessageType) {
        switch (at) {
        case 'error':
        case PuiMessageType.Error:
            this.messageType = PuiMessageType.Error;
            break;
        case PuiMessageType.Info:
            this.messageType = PuiMessageType.Info;
            break;
        case PuiMessageType.Success:
            this.messageType = PuiMessageType.Success;
            break;
        case PuiMessageType.Warning:
            this.messageType = PuiMessageType.Warning;
            break;
        default:
            this.messageType = PuiMessageType.Info;
        }
    }

    @Input() message: string;
    @Output() dismiss: EventEmitter<any> = new EventEmitter<any>();

    private messageType: PuiMessageType = PuiMessageType.Info;

    constructor() { }

    ngOnInit() { }

    onDismiss() {
        this.dismiss.emit();
    }
}
